/**
 * attentionActionError (KAN-749)
 *
 * Text of the toast shown when a "Успех" / "Отказ" / "Отработано" request
 * fails. No response (network error, server restarting) or 5xx: the click was
 * not saved and must be repeated. Otherwise the backend text (detail).
 */
import { extractErrorMessage } from '@/lib/extractErrorMessage'

export const ATTENTION_SERVER_DOWN_MESSAGE =
  'Сервер недоступен, нажатие не сохранено. Повторите.'

const FALLBACK_MESSAGE = 'Нажатие не сохранено. Повторите.'

function statusOf(err: unknown): number | undefined {
  if (err && typeof err === 'object') {
    return (err as { response?: { status?: number } }).response?.status
  }
  return undefined
}

export function attentionActionErrorMessage(err: unknown): string {
  const status = statusOf(err)
  if (status === undefined || status >= 500) return ATTENTION_SERVER_DOWN_MESSAGE
  return extractErrorMessage(err, FALLBACK_MESSAGE)
}
